export enum Flipper {
  inventoryFileCollectionMapping = 'rt_inventory_file_collection_mapping',
}
